import createReducer from "Common/reducerUtils/createReducer";
import actionTypes from "./actionTypes";
export const initialState = {
    accessLevelsKey: undefined,
    accessLevelNew: false
};
export default createReducer(initialState, {
    [actionTypes.SET_ACCESS_LEVEL_KEY]: (state, { accessLevelsKey }) => ({
        ...state,
        accessLevelsKey
    }),
    [actionTypes.SET_ACCESS_LEVEL_NEW]: (state, { accessLevelNew }) => ({
        ...state,
        accessLevelNew
    })
});
